import { storyblokInit, apiPlugin } from "@storyblok/react";
import HomeContainer from "@components/core/Storyblok/Home/HomeContainer";
import MediumBanner from "@components/core/Storyblok/Home/MediumBanner";
import LargeBannerImage from "@components/core/Storyblok/Home/LargeBannerImage";
import LargeBannerSlider from "@components/core/Storyblok/Home/LargeBannerSlider";
import CollectionList6 from "@components/core/Storyblok/Home/CollectionList6";
import HomeCollectionList3 from "@components/core/Storyblok/Home/HomeCollectionList3";
import ProductSliderV2 from "@components/core/Storyblok/Home/ProductSliderV2";
import NavSearchContainer from "@components/core/Storyblok/NavSearch/NavSearchContainer";
import NavsearchLink from "@components/core/Storyblok/NavSearch/NavsearchLink";
import NavsearchGroupLinks from "@components/core/Storyblok/NavSearch/NavsearchGroupLinks";
import NavsearchBanner from "@components/core/Storyblok/NavSearch/NavsearchBanner";
import PromoBannerContainer from "@components/core/Storyblok/PromoBanner/PromoBannerContainer";
import PromoBanner from "@components/core/Storyblok/PromoBanner/PromoBanner";
import ClosetPromoBannerContainer from "@components/core/Storyblok/ClosetPromoBanner/ClosetPromoBannerContainer";
import ClosetPromoBanner from "@components/core/Storyblok/ClosetPromoBanner/ClosetPromoBanner";
import BrandsContainer from "@components/core/Storyblok/Brands/BrandsContainer";
import BrandList3 from "@components/core/Storyblok/Brands/BrandList3";
import CatalogHeaderContainer from "@components/core/Storyblok/CatalogHeader/CatalogHeaderContainer";
import CollectionList3 from "@components/core/Storyblok/CatalogHeader/CollectionList3";
import CatalogLargeBanner from "@components/core/Storyblok/CatalogHeader/CatalogLargeBanner";

const previewMode =
  typeof window !== "undefined" ? window.location !== window.parent.location : false;

const customInitStoryblok = () =>
  storyblokInit({
    accessToken: process.env.NEXT_PUBLIC_STORYBLOK_KEY,
    use: [apiPlugin],
    // Published stories are kept in memory for the browser session, so the same story is not
    // requested again on every navigation. "auto" flushes it when Storyblok returns a new
    // cache version (after a publication). Draft stories are never cached by the SDK.
    apiOptions: { cache: { type: "memory", clear: "auto" } },
    bridge: previewMode,
    components: {
      HomeContainer,
      LargeBannerImage,
      LargeBannerSlider,
      CollectionList6,
      HomeCollectionList3,
      MediumBanner,
      ProductSliderV2,
      NavSearchContainer,
      NavsearchLink,
      NavsearchGroupLinks,
      NavsearchBanner,
      PromoBannerContainer,
      PromoBanner,
      ClosetPromoBannerContainer,
      ClosetPromoBanner,
      BrandsContainer,
      BrandList3,
      CatalogHeaderContainer,
      CollectionList3,
      CatalogLargeBanner,
    },
  });

export default customInitStoryblok;
